/*
 * @Description:
 * @Date: 2022-09-23 14:32:56
 */

export const LOGIN_PAGE_PATH = '/login'; // 登录页面地址
export const DEFAULT_PAGE_PATH = ''; // 没有默认页，以menus[0]作为默认页
export const PLATFORM_PORT = 2; // 平台类型，业务端固定2。 1 向日葵 2（工业，服务商，供应商） 3监管

/**
 * 复选框选中值, 0=未选中，1=选中
 */
export enum CheckedEnum {
  TRUE = 1,
  FALSE = 0
}

/**
 * 按钮权限类型， 1=表格按钮，2=搜索按钮，3=Tab按钮
 */
export enum PermissionBtn {
  TABLE = 1,
  SEARCH = 2,
  TAB = 3
}
/**
 * 按钮类型 Map
 */
export const PERMISSION_BUTTONS = {
  [PermissionBtn.TABLE]: {
    label: '表格按钮',
    value: PermissionBtn.TABLE
  },
  [PermissionBtn.SEARCH]: {
    label: '搜索按钮',
    value: PermissionBtn.SEARCH
  },
  [PermissionBtn.TAB]: {
    label: 'Tab按钮',
    value: PermissionBtn.TAB
  }
};
